module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', [_vm._m(0), _c('h1', [_vm._v(_vm._s(_vm.$route.meta.title))])]), _c('div', {
    staticClass: "mb-5"
  }), _c('section'), _c('div', {
    staticClass: "mb-10"
  }), _vm._m(1), _c('div', {
    staticClass: "mb-10"
  }), _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("平配圖")]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('img', {
    directives: [{
      name: "img",
      rawName: "v-img:group",
      value: ({
        src: ''
      }),
      expression: "{src: ''}",
      arg: "group"
    }],
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": require("assets/flat-map.jpg")
    }
  }), _vm._m(2)])]), _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("花博爭艷館地址：臺北市中山區玉門街 1 號")]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('img', {
    directives: [{
      name: "img",
      rawName: "v-img:group",
      value: ({
        src: ''
      }),
      expression: "{src: ''}",
      arg: "group"
    }],
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": require("assets/location-map.png")
    }
  }), _vm._m(3)]), _vm._m(4), _vm._m(5), _vm._m(6), _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "600px"
    },
    attrs: {
      "center": _vm.map.center,
      "zoom": 17,
      "mapTypeId": "roadmap",
      "options": {
        styles: _vm.map.styles
      }
    }
  }, _vm._l((_vm.map.markers), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": m.position,
        "clickable": true,
        "draggable": false,
        "icon": _vm.map.iconImg
      },
      on: {
        "click": function($event) {
          _vm.map.center = m.position
        }
      }
    }, [_c('gmap-info-window', {
      attrs: {
        "content": m.info.content
      }
    })], 1)
  }))], 1), _c('section', [_c('div', {
    staticClass: "mb-4"
  }), _c('a', {
    staticClass: "btn ghost-btn",
    attrs: {
      "href": _vm.googleCalenderEvent,
      "target": "_blank"
    }
  }, [_vm._v("加到 Google 行事曆")]), _c('div', {
    staticClass: "mb-6"
  })]), _vm._m(7), _vm._m(8), _vm._m(9), _vm._m(10), _vm._m(11), _vm._m(12), _vm._m(13), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_vm._m(14), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "mb-3"
  }), _c('router-link', {
    staticClass: "btn ghost-btn",
    attrs: {
      "to": {
        name: 'payment'
      },
      "target": "_blank"
    }
  }, [_vm._v("前往代碼繳費說明")])], 1)]), _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("可用視覺下載")]), _c('router-link', {
    staticClass: "btn ghost-btn",
    attrs: {
      "to": {
        name: 'download'
      }
    }
  }, [_vm._v("下載素材")])], 1), _c('div', {
    staticClass: "mb-3"
  }), _vm._m(15), _c('div', {
    staticClass: "mb-40"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("活動期間: 2017年11月23日－11月26日")]), _c('h4', {
    staticStyle: {
      "color": "#e0253f",
      "margin-bottom": "16px"
    }
  }, [_vm._v("各項細部時間為下：")]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("BYOC 報名時間")])]), _c('div', {
    staticClass: "content"
  }, [_vm._v("9/4 日起 － 額滿為主")])]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("BYOC 進/撤場時間")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("進場時間：11/23 12:00 － 20:00。")]), _c('li', [_vm._v("撤場時間：11/26 17:30。")])])])]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("BYOC 基本注意事項")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("1. BYOC 玩家進場時需出示有照片的身份證件，以供工作人員核對為參加者本人，方可取得感應式識別手環。")]), _c('li', [_vm._v("2. BYOC 玩家於本活動期間可憑感應式識別手環全天候 24 小時進出 BYOC 區。")]), _c('li', [_vm._v("3. BYOC 區域需出示感應式識別手環或是可通行 BYOC 的通行證才可入場。")]), _c('li', [_vm._v("4. BYOC 感應式識別手環僅限本人使用，不得授予他人進出 BYOC 區")])])])]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("一般民眾進場參觀時間")])]), _c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("日間入場時間：")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("11/23 (四) 11:00 – 20:00")]), _c('li', [_vm._v("11/24 (五) 11:00 – 20:00")]), _c('li', [_vm._v("11/25 (六) 11:00 – 20:00")]), _c('li', [_vm._v("11/26 (日) 11:00 – 17:00")])])])]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("夜間入場時間:")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("11/24 (五) 21:00 – 活動結束")]), _c('li', [_vm._v("11/25 (六) 21:00 – 活動結束")]), _c('li', [_vm._v("＊夜間入場僅開放給年滿18歲民眾，主辦單位將於入口處查驗身分證明文件。")])])])]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("主辦單位將於每日日間入場時間結束後進行清場，除參展廠商及 BYOC 玩家外之一般民眾將禁止停留在場內。為了維護現場秩序及參加者之安全，若會場內人數已達飽和數量，將進行人數控管，限制進場。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("•搭乘淡水線至捷運圓山站，下車後從 1 號出口出站。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("•搭乘淡水線至捷運圓山站，下車後從 1 號出口出站。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("搭乘公車")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("• 21、28、208、247、42、542、677、紅 2、紅 33、紅 34 （假日行駛）、紅 50 至捷運圓山站（玉門街）")]), _c('li', [_vm._v("• 246、208、542、紅 33、紅 34 （假日行駛）、218 至中山足球場站 （停靠民族東路）")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("開車")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("• 花博公園圓山地下停車場：位於玉門街 1 號 B1")]), _c('li', [_vm._v("• 兒育中心停車場：位於玉門敦煌路口（兒育出入口）北側。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("客運")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("• 轉運站名稱：圓山交通廣場 （位於捷運圓山站西側庫倫街至酒泉街之間）")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("小百科")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("BYOC？ Lan Party？ WirForce？")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("BYOC？ Lan Party？ WirForce？ 多麼陌生的名詞呀！")]), _c('li', [_vm._v("這裡請容我們簡單為你介紹這些名詞所代表的意義 !")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("什麼是 BYOC？")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("「 BYOC 」是 Bring Your Own Computer 的縮寫，意指自行攜帶電腦。")]), _c('li', [_vm._v("WirForce 正是一場 BYOC 形式的社群盛會！")]), _c('li', [_vm._v("今年的 WirForce 將有 1,000 席以上的 BYOC 名額，報名從 9 月 4 日起到額滿為止，記得趕緊報名！也別忘了到時候要帶齊你的傢伙來現場同歡。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("什麼是 Lan Party ?")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("Lan Party （網路派對）指的是由一群人暫時性、通常也是自發性的帶著他們的硬體配備與電腦 (BYOC)，在一個地方以區域網路連結的聚會，這樣的聚會大部份是以玩多人網路遊戲為目的，這樣的區域網路可大可小，從只有兩三個人到數千人都有。")]), _c('li', [_vm._v("目前世界上最大型的 Lan Party 就是瑞典的「 DreamHack 」，從原先的數百人規模到 2002 年開始壯大，每年分為夏、冬兩季，每季參與人數高達 3,000 至 6,000 人，至 2009 年起，其規模已超過 20,000 名參加者。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("什麼是 WirForce？")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("臺灣本土也有自己的 Lan Party 活動，就是 WirForce！")]), _c('br'), _c('li', [_vm._v("WirForce 於 2014 年首度舉辦時採用邀請制並不對外開放，包含各界知名實況主、名人與選手等遊戲相關人士約 200 位，各自攜帶個人電腦、筆電、配備齊聚現場。會場內除打遊戲外，參加者可以進行各種合法活動；現場亦有許多線下趣味活動與節目，內容包羅萬象精彩萬分。透過全程轉播，2014 年 WirForce 結束後立即在遊戲與電競玩家中造成轟動，並成為臺灣遊戲電競史上無人可取代的黃金傳說，說是臺灣電競遊戲界春吶一點也不為過。")]), _c('br'), _c('li', [_vm._v("許多人為錯過此  2014  盛事感到極度遺憾與扼腕，於是 2015 年的 WirForce 決定開放場外玩家自由購票報名入場後，400 張 BYOC 座位於兩天內即銷售一空，活動三天中超過兩萬名玩家與二十家國內外知名廠商一起共襄盛舉；2016年 WirForce BYOC 座位擴增至 600 席，吸引 20 家知名品牌熱列支持，在臺北市花博公園爭艷館 C2 展區舉行，免費入場的人潮上看 7 萬、線上直播觀看人次高達 100 萬。四天三夜延續不斷電的電玩派對外，電競、派對、音樂、社群、實況、改裝、最新硬體及遊戲。")]), _c('br'), _c('li', [_vm._v("今年，2017 年， WirForce BYOC 座位擴增超過 1,000 席，讓我們再次一同創造亞洲有史以來最空前的電競盛會 - WirForce!")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("我可以在 WirForce 裡做什麼？")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("如上述所言，除了瘋狂打電動外，你可以在 WirForce 會場進行各種合法活動，包含各種桌遊、競賽，在空檔之餘觀賞影片或閒聊打屁，只要你想得到的都可以作為你的活動內容，我們完全不排斥各種多角化發展，甚至還會與你一起同樂。")]), _c('li', [_vm._v("WirForce 為四天三夜不間斷的活動，歡迎各位在期間內與新舊朋友一同盡情玩樂，但也請攝取足夠的水分與熱量，更要有足夠的睡眠，請大家務必要注意自己的身體健康與人身安全。")]), _c('li', [_vm._v("若在活動期間感到任何不適，請立刻告知工作人員或前往服務台，我們會依據您的身體狀況作必要的處理。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("WirForce 有任何服裝限制嗎？")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("參加活動你不必正裝打扮，也無須費心扮裝，只要穿著你覺得舒服且不構成違法情事的裝束，其他的就是盡情享受這四天三夜吧！")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("繳費相關說明")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "14px",
      "color": "#e0253f"
    }
  }, [_vm._v("歡迎大家以各種形式參與 WirForce 2017！"), _c('br'), _vm._v("請注意！若為商業使用需經主辦單位同意。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ec9d7ab"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/activity.vue
// module id = 560
// module chunks = 1